import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { CgMenuRight, CgClose } from 'react-icons/cg';

import LanguageMenu from 'components/wrapper/_/language-menu/LanguageMenu';

export default function(BaseWrapperMenu, MenuLink, i18nService, Image, applicationService, platformService) {
	return class WrapperMenu extends BaseWrapperMenu {
		render() {
			const termsAndConditions = applicationService.settings().termsAndConditions();
			const menu = applicationService.menu();
			const logo = applicationService
				.settings()
				.headMetadata()
				.logo();

			return (
				<>
					<section
						className={classnames('header', {
							transparent: applicationService
								.settings()
								.colorScheme()
								.isMenuTransparent(),
						})}
					>
						{menu._logo ? (
							<NavLink to={menu._logo.url()}>
								<Image
									src={
										platformService.isMobile()
											? menu._logo.mobileImage || menu._logo.image
											: menu._logo.image
									}
									alt="[logo]"
									className="logo"
								/>
							</NavLink>
						) : null}
						<div className="menu-desktop">
							<div className="positions">
								<ul>
									{menu._desktopPositions.map(position => (
										<li key={position.title}>
											<MenuLink position={position} inHeader={true} />
										</li>
									))}
								</ul>
							</div>
							{menu._more ? (
								<>
									<div className="separator" />
									<div
										className="hamburger"
										onClick={event => this.openMenu(event, 'menu')}
										onTouchEnd={e => e.stopPropagation()}
									>
										<CgMenuRight />
									</div>
								</>
							) : null}
							{i18nService.availableLocales().length > 1 ? (
								<>
									<div className="separator" />
									<LanguageMenu />
								</>
							) : null}
						</div>
					</section>
					{!!this.state.isOpen ? (
						<section
							className="menu-backdrop"
							onClick={event => this.closeMenu(event)}
							onTouchEnd={e => e.stopPropagation()}
						/>
					) : null}
					<section
						className={classnames('menu', {
							open: !!this.state.isOpen,
						})}
					>
						<div className="content">
							{this.state.currentSection === 'menu' ? (
								<>
									<div className="menu-title">
										<div className="title-text">
											<FormattedMessage id="header.title.menu" />
										</div>
										<div
											className="title-close"
											onClick={event => this.closeMenu(event)}
											onTouchEnd={e => e.stopPropagation()}
										>
											<CgClose />
										</div>
									</div>
									<hr />
									<ul onClick={event => this.closeMenu(event)} onTouchEnd={e => e.stopPropagation()}>
										{menu._desktopPositions.map(position => (
											<li className="desktop-position" key={position.title}>
												<MenuLink position={position} />
											</li>
										))}
										{menu._mobilePositions.map(position => (
											<li key={position.title}>
												<MenuLink position={position} />
											</li>
										))}
									</ul>
									<hr />
									<ul onClick={event => this.closeMenu(event)} onTouchEnd={e => e.stopPropagation()}>
										{termsAndConditions.termsAndConditions ? (
											<li>
												<a
													href={termsAndConditions.termsAndConditions}
													target="_blank"
													rel="noopener noreferrer"
													className="legal-link"
												>
													<FormattedMessage
														id={'terms-and-conditions.terms-and-conditions'}
													/>
												</a>
											</li>
										) : null}
										{termsAndConditions.privacyPolicy ? (
											<li>
												<a
													href={termsAndConditions.privacyPolicy}
													target="_blank"
													rel="noopener noreferrer"
													className="legal-link"
												>
													<FormattedMessage id={'terms-and-conditions.privacy-policy'} />
												</a>
											</li>
										) : null}
										{termsAndConditions.cookiePolicy ? (
											<li>
												<a
													href={termsAndConditions.cookiePolicy}
													target="_blank"
													rel="noopener noreferrer"
													className="legal-link"
												>
													<FormattedMessage id={'terms-and-conditions.cookie-policy'} />
												</a>
											</li>
										) : null}
									</ul>
								</>
							) : null}
							{logo ? (
								<div className="menu-logo">
									<Image src={logo} />
								</div>
							) : null}
						</div>
					</section>
				</>
			);
		}
	};
}
